export default __webpack_public_path__ + "static/media/a028-example1.5649ca40.jpg";